import React from 'react';
import PropTypes from 'prop-types';
import { getModifiers } from '../../../../helpers';
import TextSummaryContent from './TextSummaryContent';

const TextSummary = ({ modifier, ...otherProps }) => (
  <div className={getModifiers('stats', modifier)}>
    <TextSummaryContent {...otherProps} />
  </div>
);

TextSummary.propTypes = {
  modifier: PropTypes.string
};

TextSummary.defaultProps = {
  modifier: ''
};

export default TextSummary;
